/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Meta_DescriptionInputs */

const de_commons_meta_description = /** @type {(inputs: Commons_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie Ihren Account, Ihre Geräte und Ihr Abo.`)
};

/** @type {(inputs: Commons_Meta_DescriptionInputs) => LocalizedString} */
const en_commons_meta_description = de_commons_meta_description;

/**

* @param {Commons_Meta_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_meta_description = /** @type {((inputs?: Commons_Meta_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Meta_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_meta_description(inputs)
	return en_commons_meta_description(inputs)
});